/**
 * EditingConfig flow DTO + completeness predicate (PF v2 native module).
 *
 * The module's durable state IS this DTO, stored at
 * `productConfigs["${cartItemId}|editing_config"]` (MODULE-CONTRACT Pattern A).
 * It mirrors the session filenames the line hands over, which is the same thing
 * `staging` does with its room map — the module's own record of the upload set,
 * kept beside the authoritative claim in `attachments`.
 *
 * WHY THE PREDICATE MAY GATE ON THE FILES HERE, when the floor plan's may not:
 * `editing_config` is DERIVED from `inputImagePolicy !== 'NONE'`
 * (`utils/purchaseFlowRevamp/sourceUploadFlow.ts`), so every product that carries
 * this flow takes the client's files by construction. There is no
 * `MOBILE_APPLICATION_FLOOR_PLAN` here — no product on this flow for which an
 * empty list is legitimate — so the requirement is decidable from the DTO alone.
 * The step's own gate still re-checks it against the catalogue, because the order
 * is built from `attachments`, not from this mirror.
 *
 * ZERO React / store imports — `modules/completeness.ts` (which
 * `store/selectors.ts` imports) pulls `editingConfigIsComplete` from here, so this
 * file stays pure.
 */

/** Plain-JSON persisted shape. */
export interface EditingConfigDraftDTO {
  /**
   * Session-scoped GCS filenames (`CartAttachment.gcFilename`) of the source
   * files this line is produced from — the same values the order's `inputImages`
   * carry.
   */
  inputImages: string[]
}

export const editingConfigIsComplete = (dto: EditingConfigDraftDTO | undefined): boolean =>
  (dto?.inputImages?.length ?? 0) > 0
